import { useEffect, useState } from 'react'

import { ContentAccordionComponent, Section } from '../contentAccordion/ContentAccordion'

interface InfoProps {
  sections: Section[]
}

export const InfoComponent = ({ sections }: InfoProps) => {
  const [openIndex, setOpenIndex] = useState<number>(0)
  useEffect(() => {
    setOpenIndex(0)
  }, [sections])
  return (
    <div className="w-full">
      {sections.map((section, index) => (
        <ContentAccordionComponent
          opened={index === openIndex}
          section={section}
          key={section.title}
          onChange={() => setOpenIndex(index)}
        />
      ))}
    </div>
  )
}
